<template>
  <div id="rncp-accordion" class="accordion accordion-icons">
    <div
      class="card accordion__card"
      v-if="
        Object.keys(data.codesNSF).length || Object.keys(data.codesROME).length || Object.keys(data.formacodes).length
      "
    >
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div
            class="collapsed accordion__heading"
            role="menu"
            data-bs-toggle="collapse"
            data-bs-target="#classification"
            aria-expanded="false"
            aria-controls="classification"
          >
            <div class="accordion-icon">
              <FontAwesomeIcon icon="fa-light fa-tag" />
            </div>
            Classification
            <div class="icons">
              <FontAwesomeIcon icon="fa-light fa-angle-down" />
            </div>
          </div>
        </section>
      </header>
      <div id="classification" class="collapse" aria-labelledby="classification" data-bs-parent="#rncp-accordion">
        <div class="card-body accordion__body">
          <TrainingRncpAccordionClassificationComponent :data="data" />
        </div>
      </div>
    </div>
    <div class="card accordion__card" v-if="Object.keys(data.activities).length">
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div
            class="collapsed accordion__heading"
            role="menu"
            data-bs-toggle="collapse"
            data-bs-target="#activities"
            aria-expanded="false"
            aria-controls="activities"
          >
            <div class="accordion-icon">
              <FontAwesomeIcon icon="fa-light fa-bullseye-arrow" />
            </div>
            {{ $t("training.rncp.targeted_activities")
            }}<span class="fw-light ms-2" v-if="data.activities"
              >({{ Object.keys(data.activities).length }} {{ $t("training.rncp.domains") }})</span
            >
            <div class="icons">
              <FontAwesomeIcon icon="fa-light fa-angle-down" />
            </div>
          </div>
        </section>
      </header>
      <div id="activities" class="collapse" aria-labelledby="activities" data-bs-parent="#rncp-accordion">
        <div class="card-body accordion__body">
          <TrainingRncpAccordionActivitiesComponent :data="data" />
        </div>
      </div>
    </div>
    <div
      class="card accordion__card"
      v-if="Object.keys(data.activitiesSector).length || Object.keys(data.employmentTypes).length"
    >
      <header class="card-header" role="tab">
        <section class="mb-0 mt-0">
          <div
            class="collapsed accordion__heading"
            role="menu"
            data-bs-toggle="collapse"
            data-bs-target="#sectors"
            aria-expanded="false"
            aria-controls="sectors"
          >
            <div class="accordion-icon">
              <FontAwesomeIcon icon="fa-light fa-briefcase" />
            </div>
            {{ $t("training.rncp.industry_sector_and_types_job") }}
            <div class="icons">
              <FontAwesomeIcon icon="fa-light fa-angle-down" />
            </div>
          </div>
        </section>
      </header>
      <div id="sectors" class="collapse" aria-labelledby="sectors" data-bs-parent="#rncp-accordion">
        <div class="card-body accordion__body">
          <TrainingRncpAccordionSectorsComponent :data="data" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import TrainingRncpAccordionClassificationComponent from "@/components/training/rncp/TrainingRncpAccordionClassificationComponent.vue";
import TrainingRncpAccordionActivitiesComponent from "@/components/training/rncp/TrainingRncpAccordionActivitiesComponent.vue";
import TrainingRncpAccordionSectorsComponent from "@/components/training/rncp/TrainingRncpAccordionSectorsComponent.vue";

export default {
  name: "TrainingRncpAccordionComponent",
  components: {
    TrainingRncpAccordionSectorsComponent,
    TrainingRncpAccordionActivitiesComponent,
    TrainingRncpAccordionClassificationComponent,
    FontAwesomeIcon,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.accordion {
  &__card + &__card {
    margin-top: 15px;
  }

  &__card {
    overflow: hidden;
    .card-header {
      border-bottom: none;
      padding: 0;
      cursor: pointer;
    }
  }

  &__heading {
    padding: 20px;
    display: flex;
    position: relative;
    font-weight: 700;
    color: var(--primary-color);

    @include dark-theme {
      color: $white;
    }

    .accordion-icon {
      margin-right: 8px;
      font-size: 16px;
    }

    .icons {
      position: absolute;
      right: 20px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>
